import utils from 'utils'
import Invoice from '../invoice1/model/Invoice'
import revertDialog from '../invoice1/view/revertDialog.html'
import submitResultPage from '../invoice1/view/submitResult.html'
import modalDetail from './view/modalDetail.html'

export default class ElectricInvoiceListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $state, getOvatAmtService, sweetalert, invoiceOpenService, initSortService, $timeout, $q, resultTipService, batchHandle, getCodeAndNumber, batchFilterService) {
        function failReasonConfirm(invList) {
            let hasErrorList = []
            invList.forEach(invoice => {
                if (invoice.description) {
                    hasErrorList.push({
                        infoId: invoice.waitId,
                        errorMsg: invoice.description,
                    })
                }
            })
            const defered = $q.defer()
            if (hasErrorList.length === 0) {
                defered.resolve()
                return defered.promise
            }
            // 强行公用批量提交结果页面
            return $uibModal.open({
                template: submitResultPage,
                controller: [
                    '$scope', '$uibModalInstance', 'sweetalert',
                    function ctrl(scope, uibModalInstance, sweetalert) {
                        scope.errorList = hasErrorList
                        scope.msg = '下列发票上次开具失败，请确认是否已经修复'
                        scope.cancel = function cancel() {
                            uibModalInstance.dismiss()
                        }
                        scope.ok = function ok() {
                            let flag = false
                            scope.errorList.forEach(invoice => {
                                if (invoice.errorMsg && (invoice.errorMsg.slice(0, 4) == '4003' || invoice.errorMsg.slice(0, 4) == '4005')) {
                                    flag = true
                                }
                            })
                            if (flag) {
                                sweetalert.confirm('操作提醒', '发票上次写库失败，请先到开票软件进行发票修复后，再点击确认。避免重复开具该发票，造成跳号错觉').then(() => {
                                    uibModalInstance.close()
                                })
                            } else {
                                uibModalInstance.close()
                            }
                        }
                    },
                ],
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-lg',
            }).result
        }

        const aMonth = utils.genPeriodByMonth()
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {},
        }
        $scope.reset = function () {
            if ($scope.active == 2) {
                $scope.param.param = {
                    applyDateStart: aMonth.start,
                    applyDateBegin: aMonth.start,
                    applyDateEnd: aMonth.end,
                    invoiceSource: 12,
                    billNumber: '',
                    billStatus: '',
                    matName: '',
                    isRed: '', // 1是、2否
                }
            } else {
                $scope.param.param = {
                    invSort: '2', // 电子票写死
                    applyDateBegin: aMonth.start,
                    applyDateEnd: aMonth.end,
                    applicant: '',
                    billCode: '',
                    blueInvoiceCode: '',
                    blueInvoiceNumber: '',
                    busSysId: '',
                    buySysName: '',
                    custCreditCode: '',
                    custName: '',
                    diskCode: '',
                    diskId: '',
                    invoiceCode: '',
                    invoiceNumber: '',
                    isList: '',
                    orgIds: '',
                    saleCreditCode: '',
                    saleName: '',
                    ukeyCode: '',
                    ukeyId: '',
                    isRed: '',
                    custNameCreditCode: '',
                    checker: '',
                    invoiceSource: '',
                    waitInvoiceStatus: '',
                    billBatchNo: '',
                }
            }
        }
        $scope.reset()

        $scope.sysUkeyList = JSON.parse(localStorage.getItem('user_info')).sysUkeyList
        // 选中的发票
        $scope.selectedInvoices = []
        // 初始化字典值，有前端写死有后台数据字典
        // 不同纸质发票 电子票没有发票种类
        function initDict() {
            const dict = {
                isRedList: [{
                    enumCode: '0',
                    enumName: '蓝票',
                }, {
                    enumCode: '1',
                    enumName: '红票',
                }, ],
                waitInvoiceStatusList: [],
            }
            const dictTypeArr = ['wait_invoice_status', 'is_list', 'invoice_source', 'invoice_status', 'is_pass', 'scan_bill_status', 'ovat_tax_rate','full_ele_export_status']
            httpRequest.get_dictByTypeArr(JSON.stringify(dictTypeArr)).then((res1) => {
                Object.assign(dict, res1.data.value)
            })
            httpRequest.post_outSystemList().then((res) => {
                const list = res.data.value
                const result = [{
                    enumTypeCode: null,
                    enumName: '全部',
                    enumCode: ''
                }]
                list.forEach((item) => {
                    const tempdata = {
                        enumTypeCode: null,
                        enumName: '',
                        enumCode: ''
                    }
                    tempdata.enumCode = item.busSysId
                    tempdata.enumName = item.busSysName
                    result.push(tempdata)
                })
                dict.out_system = result
            })
            return dict
        }
        $scope.dictionary = initDict()

        let stroageStr = 'eleInvoiceParam';
        let
            paramObj = {}

        function queryList() {
            $scope.param = sessionStorage[stroageStr] ? JSON.parse(sessionStorage[stroageStr]) : $scope.param
            const openLoading = $scope.param.pageSize >= 100 ? window.layer.msg('正在查询，请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            }) : null
            if ($scope.active == 1) {
                httpRequest.post_getOvatInvoiceWaitList($scope.param).then((res) => {
                    const result = []
                    res.data.value.list.forEach((invoice) => {
                        result.push(new Invoice(invoice))
                    })
                    $scope.invoiceList = result
                    $scope.totalItems = res.data.value.total
                    $scope.param.pageNum = res.data.value.pageNum
                    $scope.selectedInvoices = []
                }).finally(() => {
                    window.layer.close(openLoading)
                })
            } else if ($scope.active == 2) {
                httpRequest.post_qryScanInvoiceWaitOfPage($scope.param).then((res) => {
                    const result = []
                    res.data.value.list.forEach((invoice) => {
                        result.push(new Invoice(invoice))
                    })
                    $scope.invoiceList = result
                    $scope.totalItems = res.data.value.total
                    $scope.selectedInvoices = []
                }).finally(() => {
                    window.layer.close(openLoading)
                })
            }
            getData()
        }
        $scope.currentOvatAmt = {}
        $scope.$watch('selectedInvoices.length', () => {
            if (!$scope.selectedInvoices.length) {
                $scope.adValoremTotal = $scope.currentOvatAmt.adValoremTotal
                $scope.invoiceNum = $scope.currentOvatAmt.invoiceNum
                $scope.totalAmt = $scope.currentOvatAmt.totalAmt
                $scope.totalTaxamt = $scope.currentOvatAmt.totalTaxamt
                return
            }
            const {
                adValoremTotal,
                totalAmt,
                totalTaxamt
            } = getOvatAmtService($scope.selectedInvoices)
            $scope.adValoremTotal = adValoremTotal
            $scope.invoiceNum = $scope.selectedInvoices.length
            $scope.totalAmt = totalAmt
            $scope.totalTaxamt = totalTaxamt
        })

        function getData() {
            httpRequest.post_getInvoiceWaitStatics($scope.param).then((res) => {
                $scope.adValoremTotal = res.data.value.adValoremTotal.toFixed(2) || '0.00'
                $scope.invoiceNum = res.data.value.invoiceNum || 0
                $scope.totalAmt = res.data.value.totalAmt.toFixed(2) || '0.00'
                $scope.totalTaxamt = res.data.value.totalTaxamt.toFixed(2) || '0.00'
                $scope.currentOvatAmt = {
                    adValoremTotal: $scope.adValoremTotal,
                    invoiceNum: $scope.invoiceNum,
                    totalAmt: $scope.totalAmt,
                    totalTaxamt: $scope.totalTaxamt
                }
            })
        }
        // 表头排序
        $scope.orderMap = initSortService(stroageStr)
        $scope.selectedHandle = function () {
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem(stroageStr, JSON.stringify($scope.param))
            queryList()
        }
        $scope.search = function () {
            sessionStorage.setItem(stroageStr, JSON.stringify($scope.param))
            queryList()
        }
        // 分页
        $scope.totalItems = 0 // 组件初始化设置总页数
        $scope.currentPage = 1 // 设置显示第一页
        $scope.maxSize = 10 // 每一叶显示记录数
        $scope.pageChanged = function () { // 点击页码发起查询
            sessionStorage.setItem(stroageStr, JSON.stringify({
                orderMap: $scope.param.orderMap,
                pageNum: $scope.param.pageNum,
                pageSize: $scope.param.pageSize,
                param: sessionStorage[stroageStr] ? JSON.parse(sessionStorage[stroageStr]).param : paramObj,
            }))
            queryList()
        }
        /**
         * 获取是否开启审批流
         */
        function init() {
            httpRequest.post_qryFlowIsValid({
                approveCode: 'opened_invoice_approve'
            }).then((res) => {
                // 开启审批流
                $scope.isFlowOpened = res.data.value
                // queryList()
                // $scope.tabChange($scope.active)
            })
        }
        init()
        $scope.goAddPage = function goAddPage() {
            $state.go('outputManage.FOManage.eleInvoice.add', {
                invType: '51'
            })
        }
        $scope.goRedPage = function goRedPage() {
            $state.go('outputManage.FOManage.eleInvoice.addred', {
                invType: '51'
            })
        }

        function openBatchSubmitResult(result) {
            $uibModal.open({
                template: submitResultPage,
                controller: ['$scope', 'items1', '$uibModalInstance', function ctrl(scope, items1, uibModalInstance) {
                    scope.errorList = items1
                    scope.cancel = function cancel() {
                        uibModalInstance.dismiss()
                    }
                    scope.ok = function ok() {
                        uibModalInstance.close()
                    }
                }],
                openedClass: 'mod-modal mod-modal-lg',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return result
                    },
                },
            }).result.then(() => {
                queryList()
            })
        }

        function submitCallback(res) {
            utils.loaded()
            if (res.data.value.error) {
                const params = {
                    sourceCount: res.data.value.total,
                    errorCount: res.data.value.error,
                    list: res.data.value.messageList,
                    title: '提交'
                }
                resultTipService.openErrorModal(params, queryList)
            } else {
                logger.logSuccess(`提交成功${res.data.value.total}张票据`)
                queryList()
            }
        }
        // 不同于纸质发票 只有批量开票
        $scope.batchDropdownConfig = {
            btnText: '批量操作',
            options: [{
                    text: '批量提交',
                    hasPermit: 'submit_eleInvoice',
                    handler() {
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        batchFilterService.ovatBatchFilter($scope.selectedInvoices, {
                            condition: {
                                word: 'WAIT_COMMIT',
                                val: true
                            },
                            text: '提交'
                        }).then((arr) => {
                            const waitIds = []
                            for (let i = 0; i < arr.length; i++) {
                                // if (!arr[i].authMap.WAIT_COMMIT) {
                                //     logger.logError('你选择的发票中含有审核中、审核通过的发票，请重新选择')
                                //     return
                                // }
                                waitIds.push(arr[i].waitId)
                            }
                            batchHandle.open().then(data => {
                                utils.loading('系统正在批量处理中，请耐心等待... ')
                                if (data.startRow || data.endRow) {
                                    const subParams = $.extend(data, $scope.param)
                                    httpRequest.post_batchSubmitWaitRange(subParams).then(res => {
                                        submitCallback(res)
                                    })
                                } else {
                                    httpRequest.post_batchSubmitOvatInvoiceWait(waitIds).then((res) => {
                                        submitCallback(res)
                                    })
                                }
                            })

                        })
                    },
                }, {
                    text: '批量开票',
                    hasPermit: 'open_eleInvoice',
                    handler() {
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        const userInfo = JSON.parse(localStorage.getItem('user_info'))
                        const {
                            sale
                        } = userInfo
                        // if (!sale.platformPassword || !sale.authCode || !sale.platformCode) {
                        //     logger.logError('平台代码、平台密码、授权码不能为空！')
                        //     return
                        // }
                        const waitIds = []
                        for (let i = 0; i < $scope.selectedInvoices.length; i++) {
                            if (!$scope.selectedInvoices[i].authMap.WAIT_BILLING) {
                                logger.logError('你选择的发票中含未审核通过的发票，请重新选择')
                                return
                            }

                            if(!$scope.selectedInvoices[i].invoiceSource === "scan_qr_interface"){
                                logger.logError('你选择的发票中含非扫码开具的发票，请重新选择')
                                return
                            }
                            waitIds.push($scope.selectedInvoices[i].waitId)
                        }

                        if(waitIds.length > 0){//扫码开具失败发票重试
                            httpRequest.post_scanCodeInvFuilRetry(waitIds).then((res) => {
                                logger.logSuccess('提交开票成功');
                                queryList();
                                return
                            });
                        }

                        if (invoiceOpenService.chechManageTypeDiff($scope.selectedInvoices)) return logger.logError('您选择的发票开票点不是同一个类型的，请重新选择')
                        // utils.loading('开票中，请耐心等待')
                        // httpRequest.post_batchElectronOpenInv(waitIds.join(','), '').then((res) => {
                        //     window.layer.alert(res.data.value, { title: '提示' }, (index) => {
                        //         window.layer.close(index)
                        //     })
                        //     queryList()
                        // })
                        // $scope.errorNum = 0  
                        utils.loading('开票信息获取中')
                        $scope.invoiceStr = ''

                        let i = 0

                        function fn(ukeyList, invType) {
                            if (i >= ukeyList.length) {
                                utils.loaded()

                                sweetalert.confirm('操作提醒', `当前执行批量开据电子发票的单据为${$scope.selectedInvoices.length}张，请确认${$scope.invoiceStr}`).then(() => {
                                    failReasonConfirm($scope.selectedInvoices).then(() => {
                                        if (invoiceOpenService.checkIsAgent($scope.selectedInvoices[0])) {
                                            openBatch($scope.selectedInvoices, 1)
                                        } else
                                        if (invoiceOpenService.checkIsA9($scope.selectedInvoices[0].ukeyId)) {
                                            openBatch($scope.selectedInvoices, 2)
                                        } else {
                                            invoiceOpenService.checkWithDiskInfo($scope.selectedInvoices).then(() => {
                                                openBatch($scope.selectedInvoices)
                                            }, (error) => {
                                                logger.logError(error)
                                            })

                                        }
                                    })
                                })
                            } else {
                                getCodeAndNumber.getStr(ukeyList[i], invType).then(str => {
                                    i++
                                    $scope.invoiceStr += str
                                    fn(ukeyList, invType)
                                })
                            }
                        }
                        getCodeAndNumber.getUkeyList($scope.selectedInvoices, 51).then((ukeyList, invType) => {
                            fn(ukeyList, 51)
                        })
                    },
                },
                {
                    text: '批量删除',
                    hasPermit: 'del_eleInvoice',
                    handler() {
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        batchFilterService.ovatBatchFilter($scope.selectedInvoices, {
                            condition: {
                                word: 'WAIT_DELETE',
                                val: true
                            },
                            text: '删除'
                        }).then((arr) => {
                            const waitIds = []
                            for (let i = 0; i < arr.length; i++) {
                                // if (!arr[i].authMap.WAIT_DELETE) {
                                //     logger.logError('你选择的发票中含有审核中、审核通过的发票，请重新选择')
                                //     return
                                // }
                                waitIds.push(arr[i].waitId)
                            }

                            sweetalert.confirm('操作提醒', '确认删除发票？').then(() => {
                                httpRequest.post_batchDelOvatInvoiceWait(waitIds).then((res) => {
                                    if (res.data.success) {
                                        logger.logSuccess('删除成功')
                                        $timeout(() => {
                                            queryList()
                                        }, 800)
                                    } else {
                                        logger.logError(res.data.errorMsg)
                                    }
                                })
                            })

                        })
                    },
                }, {
                    text: '批量回退',
                    hasPermit: 'reduct_eleInvoice',
                    handler() {
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        batchFilterService.ovatBatchFilter($scope.selectedInvoices, {
                            condition: {
                                word: 'WAIT_FALLBACK',
                                val: true
                            },
                            text: '回退'
                        }).then(arr => {
                            const waitIds = []
                            for (let i = 0; i < arr.length; i++) {
                                // if (!arr[i].authMap.WAIT_FALLBACK) {
                                //     logger.logError(`您当前选中${arr.length}条数据，其中有一部分数据不是“审核通过”状态，不支持回退操作，请筛选后重新选择！`)
                                //     return
                                // }
                                waitIds.push(arr[i].waitId)
                            }
                            sweetalert.confirm('操作提醒', `回退后需要重新提交检测，确认回退吗？`).then(() => {
                                httpRequest.post_batchReductionOvatInvoiceWait(waitIds).then((res) => {
                                    if (res.data.success) {
                                        if (!res.data.value.error) {
                                            logger.logSuccess('回退成功')
                                        } else {
                                            const failCount = res.data.value.error
                                            const successCount = arr.length - failCount
                                            logger.logSuccess(`本次回退${arr.length}条，成功${successCount}条，失败${failCount}条，回退失败的请检查后再次操作！`)
                                        }
                                        $timeout(() => {
                                            queryList()
                                        }, 800)
                                    } else {
                                        logger.logError('回退失败')
                                    }
                                })
                            })

                        })
                    },
                },
            ],
        }
        // 批量开票
        function openBatch(invoiceList, isAgent) {

            function successCallback(errorNum) {
                isAgent && (errorNum = errorNum.length)
                utils.loaded()
                const len = invoiceList.length
                logger.logMsg({
                    title: '操作结果',
                    icon: 1,
                    message: `共计${len}张发票,成功${len - errorNum}张，失败${errorNum}张！`,
                })
                queryList()
            }

            function errorCallback() {
                utils.loaded()
                queryList()
            }

            function notifyCallback(currentIndex = 0) {
                utils.loading(`正在开具第${currentIndex + 1}张发票`)
            }
            let API = isAgent == 2 ? 'a9OpenBatch' : isAgent == 1 ? 'agentOpenBatch' : 'openBatch'
            invoiceOpenService[API](invoiceList).then(
                successCallback,
                errorCallback,
                notifyCallback,
            ).finally(() => {
                utils.loaded()
                queryList()
            })
        }
        // 回退
        function reductRequest(item) {
            httpRequest.post_reductionOvatInvoiceWait(item.waitId, '回退成功').then(() => {
                $timeout(() => {
                    queryList()
                }, 800)
            })
        }

        $scope.reduct = function reduct(item, $index) {
            httpRequest.post_checkReductionOvatInvoiceWait(item.waitId).then((res) => {
                if (res.data.value === null) {
                    reductRequest(item, $index)
                } else {
                    // 确认弹窗
                    $uibModal.open({
                        template: revertDialog,
                        controller: ['$scope', '$uibModalInstance',
                            function ctrl(scope, uibModalInstance) {
                                scope.revertData = res.data.value
                                scope.cancel = function cancel() {
                                    uibModalInstance.dismiss()
                                }
                                scope.ok = function ok() {
                                    uibModalInstance.close()
                                }
                            }
                        ],
                        backdrop: 'static',
                        openedClass: 'mod-modal mod-modal-md',
                        resolve: {
                            items1() {
                                return res.data.value
                            },
                        },
                    }).result.then(() => {
                        reductRequest(item, $index)
                    })
                }
            })
        }

        $scope.tableDropdownConfig = [{
                label: '详情',
                handler(item) {
                    const url = 'outputManage.FOManage.eleInvoice.detail'
                    window.open($state.href(
                        url, {
                            waitId: item.waitId
                        }, {
                            reload: true
                        },
                    ), '_blank')
                },
                showWhile() {
                    return true
                },
            },
            {
                label: '编辑',
                handler(item) {
                    $state.go('outputManage.FOManage.eleInvoice.edit', {
                        waitId: item.waitId,
                    })
                },
                showWhile(item, hasPermit) {
                    return item.authMap && item.authMap.WAIT_EDIT && hasPermit('add_eleInvoice')
                },
            },
            {
                label: '提交',
                handler(item) {
                    sweetalert.confirm('操作提醒', '确认提交本张发票？').then(() => {
                        invoiceOpenService.submit(item).then(() => {
                            logger.logSuccess('提交成功')
                            $timeout(() => {
                                queryList()
                            }, 800)
                        })
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('submit_eleInvoice') && item.authMap && item.authMap.WAIT_COMMIT
                },
            },
            {
                label: '开票',
                handler(item) {
                    failReasonConfirm([item]).then(() => {
                        utils.loading('开票中，请耐心等待')
                        if (invoiceOpenService.checkIsAgent(item)) {
                            utils.loading('开票中，请耐心等待')
                            invoiceOpenService.agentOpen(item, item.isRed).then(() => {
                                logger.logSuccess('开票成功')
                            }).finally(() => {
                                utils.loaded()
                                $timeout(() => {
                                    queryList()
                                }, 800)
                            })
                        } else if (invoiceOpenService.checkIsA9(item.ukeyId)) {
                            utils.loading('开票中，请耐心等待')
                            httpRequest.post_openInvoice({
                                waitId: item.waitId
                            }).then(res => {
                                if (res.data.value.code == 0) {
                                    logger.logSuccess('开票成功')
                                } else {
                                    logger.logError(res.data.value.msg)
                                }
                            }).finally(() => {
                                utils.loaded()
                                $timeout(() => {
                                    queryList()
                                }, 800)
                            })
                        } else {
                            invoiceOpenService.checkDiskAndOpen(item).then(() => {
                                utils.loaded()
                                logger.logSuccess('开票成功')
                            }, (error) => {
                                utils.loaded()
                                logger.logError(error.retmsg || error)
                            }).finally(() => {
                                $timeout(() => {
                                    queryList()
                                }, 800)
                            })
                        }
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('open_eleInvoice') && item.authMap && item.authMap.WAIT_BILLING
                },
            },
            {
                label: '回退',
                handler(item, index) {
                    $scope.reduct(item, index)
                },
                showWhile(item, hasPermit) {
                    return hasPermit('reduct_eleInvoice') && item.authMap && item.authMap.WAIT_FALLBACK
                },
            },
            {
                label: '删除',
                handler(item) {
                    sweetalert.confirm('删除提醒', '确认删除此发票?').then(() => {
                        httpRequest.post_delOvatInvoiceWait({
                            waitId: item.waitId,
                        }).then(() => {
                            logger.logSuccess('删除成功')
                            $timeout(() => {
                                queryList()
                            }, 800)
                        })
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('del_eleInvoice') && item.authMap && item.authMap.WAIT_DELETE
                },
            },
        ]
        $scope.filterUkeyName = function filterUkeyName(id) {
            const userInfo = JSON.parse(localStorage.getItem('user_info'))
            if (id === null) {
                return id
            }
            if (userInfo.sysUkeyList === null) {
                return id
            }
            const fliterUkeyNameArr = userInfo.sysUkeyList.filter((item) => item.ukeyId === id)
            if (fliterUkeyNameArr.length > 0) {
                return fliterUkeyNameArr[0].ukeyName
            }
            return id
        }
        // 查看关联销售单
        $scope.relatedBill = function relatedBill(item) {
            if (item.billNum === 0) {
                return
            }
            if (item.waitId === undefined) {
                return
            }
            $state.go('outputManage.FOManage.eleInvoice.relatedBill', {
                waitId: item.waitId
            })
        }
        // 扫码发票下拉
        $scope.scanTableDropdownConfig = [
            // {
            //     label: '详情',
            //     handler(item) {
            //         const url = 'outputManage.FOManage.eleInvoice.detail'
            //         window.open($state.href(
            //             url, { waitId: item.waitId, },
            //             { reload: true }
            //         ), '_blank')
            //     },
            //     showWhile() {
            //         return true
            //     },
            // },
            {
                label: '激活二维码',
                handler(item, index) {
                    httpRequest.post_batchActivationQRCodes([item.waitId]).then((res) => {
                        logger.logSuccess('二维码激活成功')
                    }).then(() => {
                        $timeout(() => {
                            queryList()
                        }, 800)
                    })
                },
                showWhile(item, hasPermit) {
                    return item.billStatus == '2'
                },
            },
            {
                label: '打印二维码',
                handler(item) {
                    const url = 'outputManage.FOManage.eleInvoice.printView'
                    window.open($state.href(url, {
                        waitIds: [item.waitId]
                    }, {
                        reload: true
                    }), '_blank')
                },
                showWhile(item, hasPermit) {
                    return true
                },
            },
            {
                label: '删除单据',
                handler(item) {
                    sweetalert.confirm('删除提醒', '确认删除此单据?').then(() => {
                        httpRequest.post_batchDeleteQRCodes([item.waitId]).then((res) => {
                            logger.logSuccess('删除成功')
                        }).then(() => {
                            $timeout(() => {
                                queryList()
                            }, 800)
                        })
                    })
                },
                showWhile(item, hasPermit) {
                    return true
                },
            },
        ]
        $scope.tabChange = function tabChange(v) {
            $scope.invoiceList = []
            $scope.param.pageNum = 1
            $scope.param.orderMap = {}
            $scope.orderMap = {}
            $scope.active = v
            $scope.reset()
            if (v == 2) { // 电子发票
                stroageStr = 'scanEleInvoiceParam'
                paramObj = {
                    applyDateStart: aMonth.start,
                    applyDateBegin: aMonth.start,
                    applyDateEnd: aMonth.end,
                    billNumber: '',
                    billStatus: '',
                    invoiceSource: 12,
                    matName: '',
                    isRed: '', // 1是、2否
                }
                $scope.customizedConfig = {
                    version: 1.12,
                    queryForm: [{
                        label: '单据编号',
                        selected: true,
                        default: true,
                    }, {
                        label: '主商品名称',
                        selected: true,
                        default: true,
                    }, {
                        label: '生成日期',
                        selected: true,
                        default: true,
                    }, {
                        label: '单据状态',
                        selected: true,
                        default: true,
                    }, {
                        label: '扩展1',
                        selected: false,
                        default: false,
                    }, {
                        label: '扩展2',
                        selected: false,
                        default: false,
                    }, {
                        label: '扩展3',
                        selected: false,
                        default: false,
                    }],
                    table: [{
                            label: '单据编号',
                            selected: true,
                            default: true,
                        }, {
                            label: '主商品名称',
                            selected: true,
                            default: true,
                        }, {
                            label: '合计金额',
                            selected: true,
                            default: true,
                        }, {
                            label: '合计税额',
                            selected: true,
                            default: true,
                        }, {
                            label: '价税合计',
                            selected: true,
                            default: true,
                        }, {
                            label: '含税折扣金额',
                            selected: false,
                            default: false,
                        }, {
                            label: '数据来源',
                            selected: false,
                            default: false,
                        }, {
                            label: '生成日期',
                            selected: true,
                            default: true,
                        }, {
                            label: '单据状态',
                            selected: true,
                            default: true,
                        }, {
                            label: '手机号码',
                            selected: true,
                            default: true,
                        }, {
                            label: '邮箱地址',
                            selected: true,
                            default: true,
                        }, {
                            label: '销方开户行及账号',
                            selected: false,
                            default: false,
                        }, {
                            label: '购方地址电话',
                            selected: false,
                            default: false,
                        },
                        {
                            label: '购方开户行及账号',
                            selected: false,
                            default: false,
                        }, {
                            label: '备注',
                            selected: true,
                            default: true,
                        }, {
                            label: '扩展1',
                            selected: false,
                            default: false,
                        }, {
                            label: '扩展2',
                            selected: false,
                            default: false,
                        }, {
                            label: '扩展3',
                            selected: false,
                            default: false,
                        }
                    ],
                }
                $scope.profileType = '48'
            } else {
                stroageStr = 'eleInvoiceParam'
                paramObj = {
                    invSort: '2', // 电子票写死
                    applyDateBegin: aMonth.start,
                    applyDateEnd: aMonth.end,
                    applicant: '',
                    billCode: '',
                    blueInvoiceCode: '',
                    blueInvoiceNumber: '',
                    busSysId: '',
                    buySysName: '',
                    custCreditCode: '',
                    custName: '',
                    diskCode: '',
                    diskId: '',
                    invoiceCode: '',
                    invoiceNumber: '',
                    isList: '',
                    orgIds: '',
                    saleCreditCode: '',
                    saleName: '',
                    ukeyCode: '',
                    ukeyId: '',
                    isRed: '',
                    custNameCreditCode: '',
                    checker: '',
                    invoiceSource: '',
                    waitInvoiceStatus: '',
                    billBatchNo: '',
                }
                $scope.profileType = '13'
                $scope.customizedConfig = {
                    version: 1.1315,
                    queryForm: [{
                        label: '申请日期',
                        selected: true,
                        default: true,
                    }, {
                        label: '购方名称/信用代码',
                        selected: true,
                        default: true,
                    }, {
                        label: '发票性质',
                        selected: true,
                        default: true,
                    }, {
                        label: '申请人',
                        selected: false,
                        default: false,
                    }, {
                        label: '清单标志',
                        selected: false,
                        default: false,
                    }, {
                        label: '审核状态',
                        selected: false,
                        default: false,
                    }, {
                        label: '数据来源',
                        selected: false,
                        default: false,
                    }, {
                        label: '开票点',
                        selected: false,
                        default: false,
                    }, {
                        label: '单据编号',
                        selected: false,
                        default: false,
                    }, {
                        label: '业务系统',
                        selected: false,
                        default: false,
                    }, {
                        label: '扩展1',
                        selected: false,
                        default: false,
                    }, {
                        label: '扩展2',
                        selected: false,
                        default: false,
                    }, {
                        label: '扩展3',
                        selected: false,
                        default: false,
                    },{
                        label: "全电导出状态",
                        selected: true,
                        default: false,
                    }],
                    table: [{
                            label: '待开编号',
                            selected: false,
                            default: false,
                        }, {
                            label: '发票性质',
                            selected: true,
                            default: true,
                        }, {
                            label: '购方名称/信用代码',
                            selected: true,
                            default: true,
                        }, {
                            label: '购方地址电话',
                            selected: false,
                            default: false,
                        },
                        {
                            label: '购方开户行及账号',
                            selected: false,
                            default: false,
                        }, {
                            label: '申请日期',
                            selected: true,
                            default: true,
                        }, {
                            label: '审核状态',
                            selected: false,
                            default: false,
                        }, {
                            label: '开票失败原因',
                            selected: true,
                            default: true,
                        }, {
                            label: '合计金额/税额',
                            selected: true,
                            default: true,
                        }, {
                            label: '价税合计',
                            selected: false,
                            default: false,
                        }, {
                            label: '含税折扣金额',
                            selected: false,
                            default: false,
                        }, {
                            label: '备注',
                            selected: false,
                            default: false,
                        }, {
                            label: '主商品名称',
                            selected: false,
                            default: false,
                        }, {
                            label: '税率',
                            selected: false,
                            default: false,
                        }, {
                            label: '开票点',
                            selected: false,
                            default: false,
                        }, {
                            label: '关联销售单',
                            selected: false,
                            default: false,
                        }, {
                            label: '单据编号',
                            selected: true,
                            default: true,
                        }, {
                            label: '数据来源',
                            selected: false,
                            default: false,
                        }, {
                            label: '清单标志',
                            selected: false,
                            default: false,
                        }, {
                            label: '申请人',
                            selected: false,
                            default: false,
                        }, {
                            label: '销方开户行及账号',
                            selected: false,
                            default: false,
                        },
                        {
                            label: '扩展1',
                            selected: false,
                            default: false,
                        }, {
                            label: '扩展2',
                            selected: false,
                            default: false,
                        }, {
                            label: '扩展3',
                            selected: false,
                            default: false,
                        }, {
                            label: '销方名称',
                            selected: false,
                            default: false,
                        }, {
                            label: '销方税号',
                            selected: false,
                            default: false,
                        },{
                            label: "全电导出状态",
                            selected: true,
                            default: false,
                        },{
                            label: "全电导出时间",
                            selected: true,
                            default: false,
                        }
                    ],
                }
            }
            httpRequest.get_getUserCustomized($scope.profileType).then(res => {
                if (res.data.value) {
                    let orderMap = JSON.parse(res.data.value).orderMap
                    if (orderMap) {
                        $scope.orderMap = orderMap
                    }
                }
                if ($scope.orderMap.sortKey) {
                    $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
                }
                sessionStorage.setItem(stroageStr, JSON.stringify($scope.param))
                queryList()
            })
        }
        const active = 1
        // if (!operationService.hasPermit('openedInvoice_specil')) {
        //     active = 2
        // }

        $scope.$on('$stateChangeStart', (e, toState) => {
            if (toState.name.indexOf('outputManage.FOManage.eleInvoice') == -1) {
                sessionStorage.removeItem('eleInvoiceParam')
                sessionStorage.removeItem('scanEleInvoiceParam')
                sessionStorage.removeItem('activeParam')
            } else {
                sessionStorage.setItem('activeParam', $scope.active)
            }
        })
        $scope.active = sessionStorage.activeParam ? +JSON.parse(sessionStorage.activeParam) : active
        $scope.tabChange($scope.active)

        $scope.batchActive = function () {
            if ($scope.selectedInvoices.length === 0) {
                logger.logError('请选择单据')
                return
            }
            batchFilterService.ovatBatchFilter($scope.selectedInvoices, {
                condition: {
                    word: 'billStatus',
                    val: '2'
                },
                text: '激活'
            }).then(arr => {
                const activeWaitIds = []
                arr.forEach((s) => {
                    activeWaitIds.push(s.waitId)
                })
                httpRequest.post_batchActivationQRCodes(activeWaitIds).then((res) => {
                    logger.logSuccess('批量激活成功')
                }).then(() => {
                    $timeout(() => {
                        queryList()
                    }, 800)
                })
            })
        }

        $scope.batchPrint = function () {
            if ($scope.selectedInvoices.length === 0) {
                logger.logError('请选择单据')
                return
            }
            const activeWaitIds = []
            $scope.selectedInvoices.forEach((s) => {
                activeWaitIds.push(s.waitId)
            })
            const url = $state.href('outputManage.FOManage.eleInvoice.printView', {
                waitIds: activeWaitIds
            }, {
                reload: true
            })
            window.open(url, '_blank')
        }

        $scope.batchDel = function () {
            if ($scope.selectedInvoices.length === 0) {
                logger.logError('请选择单据')
                return
            }
            const activeWaitIds = []
            $scope.selectedInvoices.forEach((s) => {
                activeWaitIds.push(s.waitId)
            })
            sweetalert.confirm('删除提醒', '确认删除选中的单据?').then(() => {
                httpRequest.post_batchDeleteQRCodes(activeWaitIds).then((res) => {
                    logger.logSuccess('批量删除成功')
                }).then(() => {
                    $timeout(() => {
                        queryList()
                    }, 800)
                })
            })
        }

        $scope.scanAdd = function () {
            $state.go('outputManage.FOManage.eleInvoice.addScan', {
                invType: '51'
            })
        }
        $scope.showMatDetail = function (invoice) {
            $uibModal.open({
                template: modalDetail,
                controller: 'modalDetailCtrl',
                openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-scan-detail',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return invoice
                    },
                },
            })
        }
        // 下载导入模板
        $scope.downOvatBill = function () {
            window.open(`${host.etcloudOvat}dlTaskService/export_OVAT_INVOICE_ELE?accessToken=${localStorage.getItem('id_token')}`)
        }
        $scope.open = function () {
            if (!JSON.parse(localStorage.user_info).sale) {
                logger.logError('该机构未配置纳税人信息，不能进行该操作')
                return
            }
            $scope.item = {
                queryOvatBillList: queryList,
                code: 'OVAT_INVOICE_ELE',
            }
            const modalInstance = $uibModal.open({
                templateUrl: './app/outputManage/fillOpenManage/ovatBill/view/ovatBillModalCtrl.html',
                controller: 'ovatBillModalCtrl',
                openedClass: 'et-ovat-bill-modal mod-modal mod-modal-lg',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return $scope.item
                    },
                },
            })
            modalInstance.result.then(() => {
                queryList()
            }, () => {})
        }
        $scope.export = () => {
            httpRequest.get_exportInvoiceWaitToXLS({...$scope.param.param,
                accessToken: localStorage.getItem('id_token')})
        }
    }
}
ElectricInvoiceListCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', '$state', 'getOvatAmtService', 'sweetalert', 'invoiceOpenService', 'initSortService', '$timeout', '$q', 'resultTipService', 'batchHandle', 'getCodeAndNumber', 'batchFilterService']


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/eleInvoice/list.js